export function AsideWidth(state = 0, action) {
  switch (action.type) {
    case 'SET_ASIDE_WIDTH': {
      return action.payload
    }
    default:
      return state
  }
}
